/*
 * Afterpay messaging amount sync (Empire Home).
 *
 * <square-placement> observes data-amount and re-renders when it changes, so this
 * script only keeps that attribute in step with the page.
 *
 * PDP:  product-info.js dispatches `variant:changed` on document after each
 *       successful variant render. It does NOT fire for unavailable option
 *       combinations (setUnavailable returns before dispatch).
 * Cart: cart.js dispatches `cart:updated` on document after re-rendering the
 *       drawer and cart page. Server-rendered placements inside the re-rendered
 *       markup already carry the new total; this is a backstop for any placement
 *       outside those regions.
 */
(function () {
  if (window.__afterpayEmpireBound) return;
  window.__afterpayEmpireBound = true;

  // Shopify money values are integer cents. Afterpay expects a decimal amount.
  function toAmount(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return null;
    return (value / 100).toFixed(2);
  }

  function setAmount(placement, amount) {
    if (placement && placement.getAttribute('data-amount') !== amount) {
      placement.setAttribute('data-amount', amount);
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant || variant.id == null || variant.price == null) return;

    var id = String(variant.id);
    var amount = toAmount(variant.price);
    if (amount === null) return;

    document.querySelectorAll('.afterpay-empire--product[data-variant-ids]').forEach(function (wrapper) {
      var ids = (wrapper.getAttribute('data-variant-ids') || '').split(',');
      // Ignore events from another product (quick view, recommendations).
      if (ids.indexOf(id) === -1) return;
      setAmount(wrapper.querySelector('square-placement'), amount);
    });
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (!cart || cart.total_price == null) return;

    var amount = toAmount(cart.total_price);
    if (amount === null) return;

    document.querySelectorAll('.afterpay-empire--cart square-placement').forEach(function (placement) {
      setAmount(placement, amount);
    });
  });
})();
